import styled from "styled-components"
import { BREAKPOINTS, TAP_MIN } from "../GlobalTheme"

const Check = styled.input<{ $isChecked: boolean }>`
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: ${props => props.theme.colors.primary};
  background-color: ${props => props.$isChecked ? props.theme.colors.primary : 'transparent'};
  width: 17px;
  height: 17px;
  border-radius: 4.7px;
  transform: translateY(0.1em);
  float: left;
  margin-right: 8px;

  @media (max-width: ${BREAKPOINTS.shell}px) {
    float: none;
    margin-right: 0px;
    flex-shrink: 0;
    transform: translateY(0.35em);
  }
  border: ${props => props.$isChecked ? 'none' : `1px solid ${props.theme.colors.gray_500}`};

  display: grid;
  place-content: center;
  cursor: pointer;

  &::before {
    content: "";
    width: 0.55em;
    height: 0.55em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    box-shadow: inset 1em 1em var(--form-control-color);
    background-color: ${props => props.theme.colors.white};
  }

  &:checked::before {
    transform: scale(1);
  }
`

const Label = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: ${props => props.theme.colors.gray_700};

  @media (max-width: ${BREAKPOINTS.shell}px) {
    font-size: 14px;
  }
`

/* A real <label> so tapping the text toggles the box. display:block keeps the previous
   <div> layout on desktop; below the breakpoint it becomes a >=44px tappable row. */
const Wrapper = styled.label`
  display: block;
  cursor: pointer;

  @media (max-width: ${BREAKPOINTS.shell}px) {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    min-height: ${TAP_MIN}px;
    padding: 6px 0px;
  }
`

export default function Checkbox({ label, value, onClick }: { label: string | JSX.Element, value: boolean, onClick: () => void }) {
  return (
    <Wrapper>
      <Check type="checkbox" checked={value} $isChecked={value} onChange={onClick} />
      <Label>{label}</Label>
    </Wrapper>
  )
}